(function carzillaDesktopBrands() {
  'use strict';
  const desktop = window.matchMedia('(min-width: 992px)');
  const config = document.currentScript || document.querySelector('script[data-czb-script]');
  if (!config) return;
  const copy = config.dataset;
  const featured = [
    ['GYEON', 'brand-gyeon'],
    ['CARPRO', 'brand-carpro'],
    ['P&S', 'brand-psdetailing'],
    ['BILT HAMBER', 'brand-bilt-hamber'],
    ['SOFT99', 'brand-soft99'],
    ['Koch-Chemie', 'brand-kochchemie'],
    ['The Rag Company', 'brand-the-rag-company'],
    ['DIY Detail', 'brand-diy-detail'],
    ["Adam's Polishes", 'brand-adams'],
    ['Active', 'brand-active-pressure-washer']
  ];
  const instances = new Map();
  const collator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base', numeric: true });
  const key = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();
  const initial = value => {
    const letter = key(value).charAt(0).toUpperCase();
    return /^[A-Z]$/.test(letter) ? letter : '0–9';
  };
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  function splitGroups(groups) {
    if (groups.length <= 3) return groups.map(group => [group]);
    const weights = groups.map(group => group.brands.length + 2);
    const sum = (start, end) => weights.slice(start, end).reduce((a, b) => a + b, 0);
    let best = null;
    for (let a = 1; a < groups.length - 1; a++) {
      for (let b = a + 1; b < groups.length; b++) {
        const counts = [sum(0, a), sum(a, b), sum(b, groups.length)];
        const score = Math.max(...counts) - Math.min(...counts);
        if (!best || score < best.score) best = { a, b, score };
      }
    }
    return [groups.slice(0, best.a), groups.slice(best.a, best.b), groups.slice(best.b)];
  }
  class BrandsMenu {
    constructor(item, index) {
      this.item = item;
      this.nav = item.closest('#navigation1');
      this.trigger = item.querySelector(':scope > a');
      this.panel = item.querySelector(':scope > .megamenu-panel');
      this.source = this.panel && this.panel.querySelector(':scope > .megamenu-lists');
      if (!this.trigger || !this.source) return;
      const seen = new Set();
      this.brands = Array.from(this.source.querySelectorAll('a.smenu')).map(link => {
        const name = (link.dataset.title || link.textContent).replace(/^Brand:\s*/i, '').trim();
        return { name, href: link.getAttribute('href') };
      }).filter(brand => {
        if (!brand.name || !brand.href || seen.has(brand.href)) return false;
        seen.add(brand.href);
        return true;
      }).sort((a, b) => collator.compare(a.name, b.name));
      if (!this.brands.length) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.saved = new Map();
      this.opened = false;
      this.range = 'all';
      this.id = 'cz-desktop-brand-directory-' + index;
      this.saveAttribute(this.trigger, 'aria-expanded', 'false');
      this.saveAttribute(this.trigger, 'aria-controls', this.id);
      this.saveAttribute(this.trigger, 'role', 'button');
      this.build();
      this.item.classList.add('cz-desktop-brands');
      this.listen(this.nav, 'click', event => {
        if (event.target.closest('.mm_parent_link') === this.trigger) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.opened ? this.close() : this.open(event.detail === 0);
        } else if (event.target.closest('.nav-menu > li > a') && !this.item.contains(event.target)) {
          this.close();
        }
      }, true);
      this.listen(this.nav, 'touchstart', event => {
        if (event.target.closest('.mm_parent_link') === this.trigger) event.stopImmediatePropagation();
      }, true);
      this.listen(this.item, 'keydown', event => {
        if (event.key === 'Escape' && this.opened) {
          event.preventDefault();
          event.stopPropagation();
          this.close(true);
        } else if (event.target === this.trigger && [' ', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          this.open(true);
        }
      });
      this.listen(document, 'pointerdown', event => {
        if (this.opened && !this.item.contains(event.target)) this.close();
      });
      this.listen(this.item, 'focusout', () => {
        window.setTimeout(() => {
          if (this.opened && !this.item.contains(document.activeElement)) this.close();
        }, 0);
      });
      this.listen(this.input, 'input', () => {
        this.range = 'all';
        this.render();
      });
      this.listen(this.input, 'search', () => {
        this.range = 'all';
        this.render();
      });
      this.listen(this.clear, 'click', () => {
        this.input.value = '';
        this.range = 'all';
        this.render();
        this.input.focus();
      });
      this.listen(this.closeButton, 'click', () => this.close(true));
      this.listen(this.filters, 'click', event => {
        const button = event.target.closest('button[data-range]');
        if (!button) return;
        this.range = button.dataset.range;
        this.input.value = '';
        this.render();
      });
      this.render();
      this.ready = true;
    }
    listen(target, name, handler, capture = false) {
      target.addEventListener(name, handler, { signal: this.signal, capture });
    }
    saveAttribute(element, name, value) {
      if (!this.saved.has(element)) this.saved.set(element, new Map());
      this.saved.get(element).set(name, element.getAttribute(name));
      element.setAttribute(name, value);
    }
    build() {
      this.shell = create('div', 'czb-shell');
      const sidebar = create('aside', 'czb-sidebar');
      sidebar.setAttribute('aria-label', copy.featured);
      const search = create('div', 'czb-search-wrap');
      const label = create('label', 'czb-sr-only', copy.search);
      label.htmlFor = this.id + '-search';
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('class', 'czb-search-icon');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('stroke', 'currentColor');
      icon.setAttribute('stroke-width', '1.7');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M20 20l-5-5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0');
      icon.append(path);
      this.input = create('input', 'czb-search');
      this.input.id = label.htmlFor;
      this.input.type = 'search';
      this.input.autocomplete = 'off';
      this.input.spellcheck = false;
      this.input.placeholder = copy.search;
      this.input.setAttribute('aria-controls', this.id);
      this.clear = create('button', 'czb-clear', '×');
      this.clear.type = 'button';
      this.clear.setAttribute('aria-label', copy.clear);
      search.append(label, icon, this.input, this.clear);
      const featuredList = create('ul', 'czb-featured');
      featured.forEach(([name, handle]) => {
        const source = this.brands.find(brand => brand.href.split('?')[0].replace(/\/$/, '').endsWith('/collections/' + handle));
        const link = create('a', '', name);
        link.href = source ? source.href : (copy.root || '/') + 'collections/' + handle;
        const chevron = create('span', 'czb-chevron');
        chevron.setAttribute('aria-hidden', 'true');
        link.append(chevron);
        const li = create('li');
        li.append(link);
        featuredList.append(li);
      });
      sidebar.append(search, create('div', 'czb-kicker', copy.featured), featuredList);
      const main = create('div', 'czb-main');
      const heading = create('div', 'czb-heading');
      this.closeButton = create('button', 'czb-close', '×');
      this.closeButton.type = 'button';
      this.closeButton.setAttribute('aria-label', copy.close);
      heading.append(create('div', 'czb-kicker', copy.browse), this.closeButton);
      this.filters = create('div', 'czb-filters');
      this.filters.setAttribute('role', 'group');
      this.filters.setAttribute('aria-label', copy.filter);
      [['all', copy.all], ['09', '0–9'], ['AD', 'A–D'], ['EL', 'E–L'], ['MR', 'M–R'], ['SZ', 'S–Z']].forEach(([range, text]) => {
        const button = create('button', 'czb-filter', text);
        button.type = 'button';
        button.dataset.range = range;
        button.setAttribute('aria-controls', this.id);
        button.setAttribute('aria-pressed', String(range === 'all'));
        this.filters.append(button);
      });
      this.status = create('div', 'czb-status');
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.status.setAttribute('aria-atomic', 'true');
      this.scroll = create('div', 'czb-scroll');
      this.scroll.id = this.id;
      this.scroll.tabIndex = 0;
      this.scroll.setAttribute('role', 'region');
      this.scroll.setAttribute('aria-label', copy.directory);
      main.append(heading, this.filters, this.status, this.scroll);
      this.shell.append(sidebar, main);
      this.panel.append(this.shell);
    }
    brandLink(brand, query = '') {
      const link = create('a', 'czb-brand');
      link.href = brand.href;
      if (query) {
        link.append(create('mark', '', brand.name.slice(0, query.length)), document.createTextNode(brand.name.slice(query.length)));
      } else link.textContent = brand.name;
      return link;
    }
    group(group) {
      const section = create('section', 'czb-group');
      const letter = create('div', 'czb-letter', group.letter);
      letter.setAttribute('aria-hidden', 'true');
      section.setAttribute('aria-label', group.letter);
      const links = create('ul', 'czb-links');
      group.brands.forEach(brand => {
        const li = create('li');
        li.append(this.brandLink(brand));
        links.append(li);
      });
      section.append(letter, links);
      return section;
    }
    render() {
      const raw = this.input.value.trim();
      const query = key(raw);
      const matches = this.brands.filter(brand => {
        if (query) return key(brand.name).startsWith(query);
        const letter = initial(brand.name);
        if (this.range === 'all') return true;
        if (this.range === '09') return letter === '0–9';
        return letter.length === 1 && letter >= this.range[0] && letter <= this.range[1];
      });
      this.clear.hidden = !raw;
      this.filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.range === this.range)));
      const template = raw ? (matches.length === 1 ? copy.oneResult : copy.results) : copy.allResults;
      this.status.textContent = template.replace('__count__', String(matches.length)).replace('__query__', raw);
      this.status.classList.toggle('czb-sr-only', !raw);
      const content = document.createDocumentFragment();
      if (!matches.length) {
        content.append(create('p', 'czb-empty', copy.empty));
      } else if (query) {
        const list = create('ul', 'czb-results');
        matches.forEach(brand => {
          const li = create('li');
          li.append(this.brandLink(brand, raw));
          list.append(li);
        });
        content.append(list);
      } else {
        const grouped = new Map();
        matches.forEach(brand => {
          const letter = initial(brand.name);
          if (!grouped.has(letter)) grouped.set(letter, { letter, brands: [] });
          grouped.get(letter).brands.push(brand);
        });
        const groups = Array.from(grouped.values()).sort((a, b) => collator.compare(a.letter, b.letter));
        const bands = this.range === 'all'
          ? [groups.filter(g => g.letter === '0–9' || g.letter <= 'G'), groups.filter(g => g.letter >= 'H' && g.letter <= 'R'), groups.filter(g => g.letter >= 'S')]
          : [groups];
        bands.filter(band => band.length).forEach(groupsInBand => {
          const band = create('div', 'czb-band');
          splitGroups(groupsInBand).forEach(groupsInColumn => {
            const column = create('div', 'czb-column');
            groupsInColumn.forEach(group => column.append(this.group(group)));
            band.append(column);
          });
          content.append(band);
        });
      }
      this.scroll.replaceChildren(content);
      this.scroll.scrollTop = 0;
    }
    geometry() {
      const rect = this.nav.getBoundingClientRect();
      const width = Math.min(1540, window.innerWidth - 64);
      const left = (window.innerWidth - width) / 2 - rect.left;
      const height = Math.min(640, Math.max(180, window.innerHeight - rect.bottom - 28));
      this.panel.style.setProperty('--czb-width', width + 'px');
      this.panel.style.setProperty('--czb-left', left + 'px');
      this.panel.style.setProperty('--czb-height', height + 'px');
    }
    open(focusSearch = false) {
      if (!desktop.matches) return;
      const navigation = window.jQuery && window.jQuery(this.nav).data('navigation');
      if (navigation) navigation.hideSubmenu(window.jQuery(this.item).siblings('li'), 'fade');
      this.geometry();
      this.opened = true;
      this.item.classList.add('cz-brands-open', 'focus');
      this.trigger.setAttribute('aria-expanded', 'true');
      if (focusSearch) this.input.focus();
    }
    close(restoreFocus = false) {
      this.opened = false;
      this.item.classList.remove('cz-brands-open', 'focus');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger.focus();
    }
    destroy() {
      if (!this.ready) return;
      this.close();
      this.controller.abort();
      this.shell.remove();
      this.item.classList.remove('cz-desktop-brands');
      ['--czb-width', '--czb-left', '--czb-height'].forEach(name => this.panel.style.removeProperty(name));
      this.saved.forEach((attributes, element) => attributes.forEach((value, name) => {
        if (value === null) element.removeAttribute(name);
        else element.setAttribute(name, value);
      }));
    }
  }
  function init() {
    instances.forEach((instance, item) => {
      if (!desktop.matches || !item.isConnected) {
        instance.destroy();
        instances.delete(item);
      }
    });
    if (!desktop.matches) return;
    document.querySelectorAll('#navigation1 .nav-menu > .mm_brandlist_container').forEach((item, index) => {
      if (instances.has(item)) return;
      const instance = new BrandsMenu(item, index);
      if (instance.ready) instances.set(item, instance);
    });
  }
  let frame = 0;
  function geometry() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      instances.forEach(instance => {
        if (instance.opened) instance.geometry();
      });
    });
  }
  desktop.addEventListener('change', init);
  window.addEventListener('resize', geometry, { passive: true });
  window.addEventListener('scroll', geometry, { passive: true });
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, item) => {
      if (event.target.contains(item)) {
        instance.destroy();
        instances.delete(item);
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
